import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
} from "@material-ui/core";
import { Select } from "@ofqual/portal-components/components/Select";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { RecipientPotentiallyUnknownOrg } from "../../../../../domain/RecipientsViewModel";
import { usersService } from "../../../../../services";

const useStyles = makeStyles((theme) => ({
  dialog: {
    height: "calc(66vh)", // try to obscure the dialog underneath
  },
}));

type AddUserDialogProps = {
  org: RecipientPotentiallyUnknownOrg;
  onClose: () => void;
  onSelect: (user: { id: string; upn: string }) => void;
};

export const AddUserDialog: React.FC<AddUserDialogProps> = ({
  org,
  onClose,
  onSelect,
}) => {
  const classes = useStyles();

  const [users] = useLookup({
    service: usersService,
    id: "id",
    label: "upn",
    params: { 
      awardingOrgId: [org.id], 
      userType: undefined,
      active: true,
    },
  });

  const processedUsers = users.map((user) => ({
    ...user,
    disabled: org.users.some((orgUser) => orgUser.id === user.id),
  }));

  const handleSelect = (userId: string) => {
    const user = users.find((user) => user.id === userId);
    if (user) {
      onSelect({ id: String(user.id), upn: user.upn });
    }
    // onClose();
  };

  appendEmptyMessageIfEmpty(processedUsers);

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Add staff permission - select a user</DialogTitle>
      <DialogContent className={classes.dialog}>
        <Grid container spacing={3}>
          <Grid item xs={12}></Grid>
          <Grid item xs={12}>
            <Select
              label="Select a user"
              onChange={(val) => handleSelect(val.target.value)}
              fullWidth
              datatest="assign-select-user-field"
            >
              {processedUsers}
            </Select>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          component="button"
          color="primary"
          onClick={onClose}
          data-test="select-user-close-button"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const appendEmptyMessageIfEmpty = (items: ReturnType<typeof useLookup>[0]) => {
  if (!items.length && !items.isPlaceholder) {
    items.push({
      id: "",
      label: "This organisation does not have any user records in the portal",
      disabled: true,
    });
  }
};
